// Metadatos visuales compartidos por estado de cobro (chip de estado, filas rojas, etc.)
export const ESTADOS_COBRO = {
    A_COBRAR: { label: 'A cobrar', color: '#92400e', bg: '#fef3c7' },
    ALTA: { label: 'Alta', color: '#1e40af', bg: '#dbeafe' },
    EN_CUOTAS: { label: 'En cuotas', color: '#5b21b6', bg: '#ede9fe' },
    // CANCELADO = saldado (no "anulado": eso es BAJA). Se muestra "Pagado" para que no se confunda.
    CANCELADO: { label: 'Pagado', color: '#166534', bg: '#dcfce7' },
    BAJA: { label: 'Baja', color: '#374151', bg: '#e5e7eb' },
};

export function ChipEstadoCobro({ estado }) {
    const meta = ESTADOS_COBRO[estado] || { label: estado || '—', color: '#374151', bg: '#e5e7eb' };
    return (
        <span
            className="badge"
            style={{ background: meta.bg, color: meta.color, padding: '0.5rem 0.8rem', borderRadius: '6px', fontSize: '0.8rem', fontWeight: 600 }}
        >
            {meta.label}
        </span>
    );
}

// Estado de una cuota, con los mismos colores en el plan de cuotas de todas las pantallas.
export const META_CUOTA = {
    pagada: { label: 'Pagada', color: '#166534', bg: '#dcfce7', borde: '#22c55e' },
    vencida: { label: 'Vencida', color: '#991b1b', bg: '#fee2e2', borde: '#ef4444' },
    anulada: { label: 'Anulada', color: '#6b7280', bg: '#f1f5f9', borde: '#cbd5e1' },
    pendiente: { label: 'Pendiente', color: '#92400e', bg: '#fef3c7', borde: '#f59e0b' },
};

// Anulada gana sobre pagada, y pagada sobre vencida: una cuota que se pagó tarde ya no está vencida.
export function estadoCuota(c) {
    if (c.anulada) return 'anulada';
    if (c.pagada) return 'pagada';
    if (c.vencida) return 'vencida';
    return 'pendiente';
}

export function ChipEstadoCuota({ cuota }) {
    const meta = META_CUOTA[estadoCuota(cuota)];
    return (
        <span className="badge rounded-pill fw-semibold" style={{ background: meta.bg, color: meta.color }}>{meta.label}</span>
    );
}
